<template>
    <b-modal id="enabling-datavant-tokenizaton-modal" ref="enablingDatavantTokenizationModal" hide-header-close hide-footer :no-close-on-esc="noCloseOnBackdrop" :no-close-on-backdrop="noCloseOnBackdrop">
        <template slot="modal-title"></template>
        <span class="cross-icon" @click="cancel()">&times;</span>
        <div class="heading">
            <span class="title">Enabling Datavant Tokenization would add</span><br />
            <span class="subtitle1">eConsent & Datavant Tokenization</span><br />
            <span class="subtitle2">Consent to Study Design.</span>
            <div class="heading1">
                <span class="title">The Datavant Tokenization Consent can be</span><br />
                <span class="subtitle3">set up by navigating to eConsent element.</span><br />
            </div>
            <p>Would you like to continue?</p>
        </div>
        <div class="modal-button-container">
            <button class="button-cancel" @click="cancel">Cancel</button>
            <button class="button-confirm" v-on:click="showDatavantTokenModal">Yes</button>
        </div>
    </b-modal>
</template>
<script>

export default {
    name: "enabling-datavant-tokenization-modal",
    data() {
        return {
            noCloseOnBackdrop: true,
        };
    },
    methods: {
        show() {
            this.$refs.enablingDatavantTokenizationModal.show();
        },
        showDatavantTokenModal() {
            this.$emit("datavantModalEvent");
        },
        cancel() {
            this.$emit("cancel-event", false);
            this.$refs.enablingDatavantTokenizationModal.hide();
        },
    },
};
</script>
<style lang="scss">
#enabling-datavant-tokenizaton-modal {
    @media (min-width: 469px) {
        .modal-dialog {
            width: 469px;
            height: 328px;
            vertical-align: middle;
        }

        .cross-icon {
            float: right;
            font-size: 31px;
            font-weight: 500;
            cursor: pointer;
            margin-top: -28px;
            margin-right: 5px;
            color: #666669;
        }

        .modal-header {
            border-bottom: none !important;
        }

        .modal-body {
            padding-top: 0px;
        }

        .heading {
            line-height: 1.3;
            margin-top: 16px;
        }

        span.title {
            font-size: 20px;
            color: #666669;
            font-family: Roboto-bold;
            margin-left: 29px;
        }

        span.subtitle1 {
            font-size: 20px;
            color: #666669;
            font-family: Roboto-bold;
            margin-left: 64px;
        }

        span.subtitle2 {
            font-size: 20px;
            color: #666669;
            font-family: Roboto-bold;
            margin-left: 99px;
        }

        .heading1 {
            margin-top: 18px;
        }

        span.subtitle3 {
            font-size: 20px;
            color: #666669;
            font-family: Roboto-bold;
            margin-left: 32px;
        }

        p {
            margin-top: 12px;
            margin-left: 119px;
            font-size: 16px;
        }

        .modal-button-container {
            display: flex;
            justify-content: center;
            align-items: center;
            margin-top: 20px;
            margin-bottom: 6px;
        }

        .button-cancel {
            color: #666669;
            margin: 0 10px;
            width: 146.9px;
            height: 41px;
            border: solid 1px #b0bac9;
            font-size: 16px;
            background-color: #fff !important;
            font-size: 14px !important;
            border-radius: 4px;
            font-family: Roboto-Medium;
            cursor: pointer;
            color: #4c8ce4;
        }

        .button-confirm {
            width: 155px;
            height: 41px;
            color: #fff;
            border: 1px solid #4c8ce4;
            background-color: #4c8ce4;
            cursor: pointer;
            font-size: 14px !important;
            color: #fff !important;
            border-radius: 4px;
            font-family: Roboto-Medium;
        }
    }
}
</style>
